import { createAsyncThunk } from '@reduxjs/toolkit';
import PlacementApi from '@infrastructure/placement-api';
import { getErrorPayload } from '@application/common/helpers/api-helper';
import { addSuccessNotification } from '../common/notificationSlice';
import { translate } from '@application/common/helpers/translate';
export const getAllPlacementsAsync = createAsyncThunk('placement/getAll', async ({ status }, { rejectWithValue }) => {
    try {
        const apiStatus = status === null ? undefined : status;
        const response = await PlacementApi.getAllPlacements(apiStatus);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getPlacementByIdAsync = createAsyncThunk('placement/getById', async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await PlacementApi.getPlacementById(id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updatePlacementStatusAsync = createAsyncThunk('placement/updateStatus', async (request, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await PlacementApi.updatePlacementStatus(request);
        dispatch(addSuccessNotification(translate('placement.statusUpdatedSuccessfully')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updatePermanentPlacementDTOAsync = createAsyncThunk('placement/updatePermanentPlacement', async (request, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await PlacementApi.updatePermanentPlacement(request);
        dispatch(addSuccessNotification(translate('placement.placementUpdatedSuccessfully')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateContractPlacementAsync = createAsyncThunk('placement/updateContractPlacement', async (request, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await PlacementApi.updateContractPlacement(request);
        dispatch(addSuccessNotification(translate('placement.placementUpdatedSuccessfully')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateSecondmentPlacementAsync = createAsyncThunk('placement/updateSecondmentPlacement', async (request, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await PlacementApi.updateSecondmentPlacement(request);
        dispatch(addSuccessNotification(translate('placement.placementUpdatedSuccessfully')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
